import { ADD,MODYFIKACJA,KASOWANIE } from "./typyAkcji";
import { startDane } from './dane'

const reduktor = (dane,akcja) => {
    switch (akcja.type) {
        case ADD:
            return {
                ...dane,
                [akcja.dataType] : //akcja.dane
                dane[akcja.dataType].concat([akcja.dane])
            }
        case MODYFIKACJA:
           let oldObj = dane[akcja.dataType]
           let newObj = akcja.dane
           let keys = [...Object.keys(oldObj),...Object.keys(newObj)]
           let obiekt = {}
           keys.map(k =>  Object.hasOwn(newObj,k) ? obiekt[k] = newObj[k] : obiekt[k] = oldObj[k])
            return{
               ...dane,
                [akcja.dataType] :obiekt 
                 //filtmap( p => 
                //    p.id === akcja.dane.id ? akcja.dane : p)
            }
            
        case KASOWANIE:
            return {
                ...dane,
                [akcja.dataType]: []
                //dane[akcja.dataType].filter(p => p.id !== akcja.dane.id)
            }
        default:
            console.log(startDane)
            return dane || startDane
    }
}
export default reduktor
